import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { useWaitForModalResult } from '../useWaitForModalResult';

import { useTracking } from './hooks/useTracking';

export function useConfirmHighAmount(): (paymentType: PaymentType) => Promise<boolean> {
	const { trackAmountTooHighView, trackAmountTooHighConfirm, trackAmountTooHighCancel } = useTracking();

	const {
		data: {
			promotionCountrySettings: { confirmationAmount },
			featureConfigs: { highAmountConfirmationModal },
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();

	const waitForModalResult = useWaitForModalResult();

	return async function confirmHighAmount(paymentType): Promise<boolean> {
		if (
			!highAmountConfirmationModal ||
			!confirmationAmount ||
			amount < confirmationAmount ||
			paymentType === 'paypal'
		) {
			return Promise.resolve(true);
		}

		void trackAmountTooHighView();
		const result = await waitForModalResult('highAmount');
		if (result) {
			void trackAmountTooHighConfirm();
		} else {
			void trackAmountTooHighCancel();
		}
		return result;
	};
}
